/**
 * Starting outlines for each kind of event. The admin picks one when writing
 * an event's details, then edits the words. Kept to what EGKA events need:
 * timetable, what to bring, venue, gradings, and anything special.
 */

export const EVENT_TEMPLATES: Record<string, string> = {
  gasshuku: `## About
A weekend of training for all grades with senior EGKA instructors.

## Timetable
### Saturday
- 09:30 Registration
- 10:00 Training
- 12:30 Lunch
- 13:30 Training
- 16:00 Finish

### Sunday
- 09:30 Registration
- 10:00 Training
- 15:00 Finish

## What to bring
- Clean gi and your belt
- Your EGKA membership is checked at registration
- Water and a packed lunch
- Gum shield and mitts if you have them

## Gradings
Enter the grading online from this page and your sensei will be asked to approve your entry. The grading fee is paid at the registration desk.

## Venue and parking
Add the full address, parking and public transport here.

## Special instructions
Anything else people need to know, for example juniors must be collected by a parent or guardian.`,

  grading: `## About
Enter online from this page. Your sensei is asked to approve your entry, and we email you their decision.

## On the day
- 09:30 Registration
- 10:00 Grading starts

## What to bring
- The grading fee, paid at the registration desk
- Clean gi and your current belt
- Water

## Results
Certificates are sent to your instructor after the grading.

## Venue and parking
Add the full address and parking here.`,

  course: `## About
What the course covers and who it is for.

## Timetable
- 10:00 Start
- 12:30 Finish

## What to bring
- Clean gi and your belt
- Water

## Venue and parking
Add the full address and parking here.`,

  agm: `## About
The EGKA Annual General Meeting. All members are welcome.

## How to join
Book below and we'll email the online meeting link a few days beforehand.

## Agenda
1. Welcome
2. Chair's report
3. Treasurer's report
4. Election of committee
5. Any other business

## Agenda items and nominations
Send agenda items and committee nominations to the membership secretary by the date given in the AGM notice.`,
};
EVENT_TEMPLATES.competition = EVENT_TEMPLATES.course!;
EVENT_TEMPLATES.seminar = EVENT_TEMPLATES.course!;
EVENT_TEMPLATES.other = EVENT_TEMPLATES.course!;
